module.exports = __webpack_public_path__ + "static/media/kayleenOlson.e2c6cd46.jpg";